import * as React                                                                                               from 'react';
import { createStyles, makeStyles, Theme, withStyles }                                                          from '@material-ui/core/styles';
import Typography                                                                                               from '@material-ui/core/Typography';
import CssBaseline                                                                                              from '@material-ui/core/CssBaseline';
import Grid                                                                                                     from '@material-ui/core/Grid';
import Avatar                                                                                                   from '@material-ui/core/Avatar';
import TextField                                                                                                from '@material-ui/core/TextField';
import Container                                                                                                from '@material-ui/core/Container';
import FormControl                                                                                              from '@material-ui/core/FormControl';
import Rating                                                                                                   from '@material-ui/lab/Rating';
import Box                                                                                                      from '@material-ui/core/Box';
import Button                                                                                                   from '@material-ui/core/Button';
import FeedbackIcon                                                                                             from '@material-ui/icons/Feedback';
import AttachFileIcon                                                                                           from '@material-ui/icons/AttachFile';
import ClearIcon                                                                                                from '@material-ui/icons/Clear';
import MenuItem                                                                                                 from '@material-ui/core/MenuItem';
import Files                                                                                                    from 'react-files';
import { FormGroup, FormControlLabel, Checkbox, Card, CardContent, CardHeader, IconButton, Select, InputLabel, Tooltip } from '@material-ui/core';
import { RowFeedbackparameters, RowFeedbackTypes }                                                              from 'src/reducers/completeorderfile';

export interface FeedbackPageViewProps {
    saveComments: (comments: string) => void;
    saveRating: (rating: number) => void;
    saveFbType: (value: string) => void;
    onSubmit: () => void;
    onReset: () => void;
    onResetFbParams: () => void;

    totalRating: number;
    comments: string;
    fbtype: string;
    onFilesError: (error: Error, images: Array<File>) => void;
    onFilesChange: (submitFbFiles: Array<File>) => void;
    deleteRowbyId: () => void;
    submitFbFiles: Array<File>;
    handleCheckboxChange: (value: string, list: string, checked: boolean) => void;
    checkedValuesGeneral: () => void;
    checkedValuesAnterior: () => void;
    checkedValuesCopings: () => void;
    checkedValuesModel: () => void;
    checkedValuesAbutment: () => void;
    checkedValuesCutback: () => void;
    orderno: string;
    orderdate: string;
    completedon: string;
    tat: string;
    fname: string;
    tool_preferred: string;
    destination: string;
    modelonly: string;
    approval_reqd: string;
    bravopremium: string;
    nounits: string;
    fbparameters: RowFeedbackparameters[];
    fbtypes: RowFeedbackTypes[];
    selectedCheckedParameters: { [key: string]: string[] }; // New prop to track checked parameters
    updateSelectedCheckedParameters: (selectedCheckedParameters: { [key: string]: string[] }) => void;
}

// interface FileType {
//     id: string;
//     name: string;
//     file: File;
//   }

const labels: { [index: string]: string } = {
    1: 'Below Expectations',
    2: 'Average',
    3: 'Good',
    4: 'Very Good',
    5: 'Excellent',
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: '100%',
        },
        fontValues: {
            '& .MuiTypography-body1': {
                fontSize: '0.8rem'
            }
        },
        filesDropzoneActive: {
            border: '3px solid #3f51b5',
            color: '#3f51b5',
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        avatar: {
            backgroundColor: theme.palette.secondary.main
        },
        form: {
            width: '100%', // Fix IE 11 issue.
        },
        submit: {
            margin: theme.spacing(1),
            alignItems: 'center'
        },
        rating: {
            // margin: theme.spacing(1),
            width: '100%',
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'start',
            fontSize: '1rem',
        },
        rating_In: {
            // fontSize: '2.2rem',
            color: '#f50057'
        },
        card: {
            marginTop: theme.spacing(1),
            transition: theme.transitions.create(['all'], {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        grid_margin: {
            margin: '15px 5px 0px 5px'
        },
        fontCenter: {
            '& .MuiInputBase-input.Mui-disabled': {
                textAlign: 'start'
            }
        },
        gridList: {
            width: 'auto',
            height: 'auto',
        },
        colorHeading: {
            fontSize: '1rem',
            color: 'rgb(3, 129, 237)'
        },
    })
);

const Cards = withStyles({
    root: {
        '& .MuiCardContent-root:last-child': {
            paddingBottom: '8px'
        },
    }
})(Card);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);
 
const FeedbackPageView: React.StatelessComponent<FeedbackPageViewProps> = props => {
    const classes = useStyles({});
    const [hover, setHover] = React.useState(-1);
    const [charCount, setCharCount] = React.useState(0);   
    
    const [selectedFeedbackTypes, setSelectedFeedbackTypes] = React.useState<
    string[]
  >(() => {
    props.saveFbType(''); // Save an empty string instead
    return []; // Return an empty array
  });

    const filteredFeedbackParameters = props.fbparameters.filter(
        param => selectedFeedbackTypes.includes(param.feedbacktype)
    );

    // const handleFeedbackTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    //     const selectedTypes = event.target.value as string[];
    //     setSelectedFeedbackTypes(selectedTypes);
    //     const selectedTypesString = selectedTypes.join(',');
    //     props.saveFbType(selectedTypesString);
    //     props.onResetFbParams();
    // };
 
    const handleRatingChange = (newValue: number) => {
        // Clear feedback types and checked parameters if rating is 5
        if (newValue === 5) {
            setSelectedFeedbackTypes([]);
            // props.updateSelectedCheckedParameters({});
            props.saveFbType('');
        }
        
        props.saveRating(newValue);
        // props.onResetFbParams();
    };

    // const handleFeedbackTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    //     const selectedTypes = event.target.value as string[];
        
    //     // Create a copy of the current selected checked parameters
    //     const updatedCheckedParameters = { ...props.selectedCheckedParameters };
    //     // Remove keys for types that are no longer selected
    //     Object.keys(updatedCheckedParameters).forEach(type => {
    //         if (!selectedTypes.includes(type)) {
    //             delete updatedCheckedParameters[type];
    //         }
    //     });

    //     // Update the selected checked parameters
    //     props.updateSelectedCheckedParameters(updatedCheckedParameters);
    //     // Update selected feedback types
    //     setSelectedFeedbackTypes(selectedTypes);
    //     const selectedTypesString = selectedTypes.join(',');
    //     props.saveFbType(selectedTypesString);
    // };

    // Function to format selected values for tooltip
    const getTooltipContent = (selected: string[]) => {
        if (selected.length === 0) {
            return 'No types selected';
        }
        return selected.join(', ');
    };
// Modified to clear checkbox values only when feedback type changes
    const handleFeedbackTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newSelectedTypes = event.target.value as string[];
    const oldSelectedTypes = selectedFeedbackTypes;
    
    // Create a copy of the current selected checked parameters
    const updatedCheckedParameters = { ...props.selectedCheckedParameters };
    
    // Find removed feedback types
    const removedTypes = oldSelectedTypes.filter(type => !newSelectedTypes.includes(type));
    
    // Remove checked parameters for removed feedback types
    removedTypes.forEach(type => {
        delete updatedCheckedParameters[type];
    });
    
    // Initialize empty arrays for newly added feedback types
    newSelectedTypes.forEach(type => {
        if (!oldSelectedTypes.includes(type)) {
            updatedCheckedParameters[type] = [];
        }
    });

    // Update the selected checked parameters
    props.updateSelectedCheckedParameters(updatedCheckedParameters);
    
    // Update selected feedback types
    setSelectedFeedbackTypes(newSelectedTypes);
    props.saveFbType(newSelectedTypes.join(', '));
};
    const handleCommentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const text = event.target.value;
        const chars = text.length;
        
        if (chars <= 1000) {
            setCharCount(chars);
            props.saveComments(text);
        }
    };

    // const General = [
    //     'Anatomy too washout',
    //     'Contact-Tight/Loose',
    //     'Contour-Under/Over',
    //     'Default Parameters-Not followed',
    //     'Insertion Direction not good',
    //     'Margin Line short',
    //     'Margin too thick/thin',
    //     'Marginal ridges-not Matching',
    //     'Material Settings/Material- not correct',
    //     'Occlusal table-not matching',
    //     'Occlusion-High/low',
    //     'Pre-Op not matching',
    //     'Rest Shape is not good',
    //     'RX not follow',
    //     'Shape/Size- Not appropriate',
    //     'TAT issue'
    // ];
    // const Anterior = [ 835
    //     'Adjacent tooth form-not matching',
    //     'Arch Form-not correct',
    //     'Height too long/short',
    //     'Height/Width Ratio',
    //     'Incisal Embrasures not good',
    //     'Line angles not matching',
    //     'Lingual Anatomy missing',
    //     'Long Axis of tooth- Not matching',
    //     'Mid line not matching'
    // ];
    // const Copings = [`Doesn't provide ceramic support`, 'Lingual band-missing', 'Too bulky'];
    // const Model = ['Die margin is manipulated', 'Die margin not marked properly', `Model's Text is not correct/missing`];
    // const Abutment = [
    //     'Emergence profile- not correct',
    //     'Gingival compression- too less/too much',
    //     'Height too short/too long',
    //     'Retention groove/slice- missing',
    //     'Tissue level- not accurate',
    //     'Too tapered/too broad'
    // ];
    // const Cutback = [
    //     'Cutback level-not correct',
    //     'Too flared'
    // ];
 
    // Handle checkbox change
    // const handleCheckboxChange = (feedbackType: string, listType: string, checked: boolean) => {
    //     // Create a copy of the current selected checked parameters
    //     const updatedCheckedParameters = { ...props.selectedCheckedParameters };

    //     // If the feedback type doesn't exist in the object, create an empty array
    //     if (!updatedCheckedParameters[feedbackType]) {
    //         updatedCheckedParameters[feedbackType] = [];
    //     }

    //     // Add or remove the list type based on checked status
    //     if (checked) {
    //         if (!updatedCheckedParameters[feedbackType].includes(listType)) {
    //             updatedCheckedParameters[feedbackType].push(listType);
    //         }
    //     } else {
    //         const index = updatedCheckedParameters[feedbackType].indexOf(listType);
    //         if (index > -1) {
    //             updatedCheckedParameters[feedbackType].splice(index, 1);
    //         }
    //     }
    //     // Update the selected checked parameters
    //     props.updateSelectedCheckedParameters(updatedCheckedParameters);
    //     // Call the original handleCheckboxChange prop if needed
    //     props.handleCheckboxChange(feedbackType, listType, checked);
    // };
    
    // Handle checkbox change - remains the same
    const handleCheckboxChange = (feedbackType: string, listType: string, checked: boolean) => {
        const updatedCheckedParameters = { ...props.selectedCheckedParameters };

        if (!updatedCheckedParameters[feedbackType]) {
            updatedCheckedParameters[feedbackType] = [];
        }

        if (checked) {
            if (!updatedCheckedParameters[feedbackType].includes(listType)) {
                updatedCheckedParameters[feedbackType].push(listType);
            }
        } else {
            const index = updatedCheckedParameters[feedbackType].indexOf(listType);
            if (index > -1) {
                updatedCheckedParameters[feedbackType].splice(index, 1);
            }
        }
        
        props.updateSelectedCheckedParameters(updatedCheckedParameters);
        props.handleCheckboxChange(feedbackType, listType, checked);
    };
     // Add a function to handle file size validation
    const handleFilesError = (error: Error, files: Array<File>) => {      
        if (error.message) {
            // alert('File size exceeds 50MB limit. Please choose a smaller file.');
            alert(error.message);
        }
        props.onFilesError(error, files);
    };
    
    const handleReset = () => {
        // Clear local state
        setSelectedFeedbackTypes([]);
        setCharCount(0);
        setHover(-1);
        
        // Clear checked parameters
        props.updateSelectedCheckedParameters({});
        
        // Call the original reset
        props.onReset();
    };

    return (
        <div className={classes.root}>
            <Container component="main" maxWidth="lg">
                <CssBaseline />
                <div className={classes.paper}>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="recipe" className={classes.avatar}>
                                <FeedbackIcon />
                            </Avatar>}
                        title={<Typography component="h1" variant="h5">Feedback</Typography>}
                    />
                    <div className={classes.form}>
                        <Cards className={classes.card}>
                            <CardContent>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Order No"
                                            disabled
                                            defaultValue="ORD"
                                            value={props.orderno !== '' ? props.orderno : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Received On"
                                            disabled
                                            defaultValue=""
                                            value={props.orderdate !== '' ? props.orderdate : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Completed On"
                                            disabled
                                            defaultValue=""
                                            value={props.completedon !== '' ? props.completedon : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="TAT"
                                            disabled
                                            defaultValue=""
                                            value={props.tat !== '' ? props.tat : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={6}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="File Name"
                                            disabled
                                            defaultValue=""
                                            value={props.fname !== '' ? props.fname : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Software Used"
                                            disabled
                                            defaultValue=""
                                            value={props.tool_preferred !== '' ? props.tool_preferred : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Destination"
                                            disabled
                                            defaultValue=""
                                            value={props.destination !== '' ? props.destination : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Units Counts​"
                                            disabled
                                            defaultValue=""
                                            value={props.nounits !== '' ? props.nounits : '-'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Model Only​"
                                            disabled
                                            defaultValue=""
                                            value={props.modelonly === 'Y' ? 'Yes' : 'No'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Design Approval​"
                                            disabled
                                            defaultValue=""
                                            value={props.approval_reqd === '1' ? 'Required' : 'No'}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <CssTextField
                                            className={classes.fontCenter}
                                            size="small"
                                            fullWidth
                                            label="Bravo/Premium​"
                                            disabled
                                            defaultValue=""
                                            value={props.bravopremium === '1' ? 'Yes' : 'No'}
                                        />
                                    </Grid>
                                   {/* 
                                    <Grid item xs={12} sm={4} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Feedback Type</InputLabel>
                                            <Select
                                                value={props.fbtype || ''}
                                                onChange={(event) => {
                                                    const selectedType = event.target.value as string;
                                                    props.saveFbType(selectedType);
                                                    props.onResetFbParams();
                                                    // const filteredList = props.fbparameters.filter(
                                                    //     (data) => data.feedbacktype === selectedType
                                                    // );
                                                    // setFbList(filteredList);
                                                }}
                                            >
                                                {props.fbtypes.map((fb, index) => (
                                                <MenuItem key={index} value={fb.feedbacktype}>
                                                    {fb.feedbacktype}
                                                </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    */}
                                 {/* 
                                    <Grid item xs={12} sm={4} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Feedback Types</InputLabel>
                                            <Select
                                                multiple
                                                value={selectedFeedbackTypes}
                                                onChange={handleFeedbackTypeChange}
                                                renderValue={(selected) => (selected as string[]).join(', ')}
                                            >
                                                {props.fbtypes
                                                    .filter(fb => fb.feedbacktype) // Remove null entries
                                                    .map((fb, index) => (
                                                    <MenuItem key={index} value={fb.feedbacktype}>
                                                        <Checkbox 
                                                            checked={selectedFeedbackTypes.indexOf(fb.feedbacktype) > -1} 
                                                            color="primary" 
                                                        />
                                                        {fb.feedbacktype}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid> */}                                     
                                    <Grid item xs={12} sm={4} md={3}>
                                        <div className={classes.rating}>
                                            Rating :
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <div className={classes.rating}>
                                            <Rating
                                                size="large"
                                                className={classes.rating_In}
                                                name="hover-feedback"
                                                value={props.totalRating}
                                                precision={1}
                                                // onChange={(event, newValue) => {
                                                //     props.saveRating(newValue as number);
                                                //     props.onResetFbParams();
                                                // }}
                                                // onChangeActive={() => {
                                                //     setHover(hover);
                                                // }}
                                                onChange={(event, newValue) => {
                                                    handleRatingChange(newValue as number);
                                                }}
                                                onChangeActive={(event, newHover) => {
                                                    setHover(newHover);
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                     <Grid item xs={12} sm={4} md={3}>
                                        <div className={classes.rating}>
                                            {props.totalRating !== null && <Box style={{ justifyContent: 'center' }}>{labels[hover !== -1 ? hover : props.totalRating]}</Box>}
                                        </div>
                                    </Grid>
                                    {/* {props.totalRating < 5 && (
                                    <Grid item xs={12} sm={4} md={3}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Feedback Type</InputLabel>
                                            <Select
                                                multiple
                                                value={selectedFeedbackTypes}
                                                onChange={handleFeedbackTypeChange}
                                                renderValue={(selected) => (selected as string[]).join(', ')}
                                            >
                                                {props.fbtypes
                                                    .filter(fb => fb.feedbacktype) // Remove null entries
                                                    .map((fb, index) => (
                                                    <MenuItem key={index} value={fb.feedbacktype}>
                                                        <Checkbox 
                                                            checked={selectedFeedbackTypes.indexOf(fb.feedbacktype) > -1} 
                                                            color="primary" 
                                                        />
                                                        {fb.feedbacktype}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    )} */}
                                     {props.totalRating < 5 && (
                                        <Grid 
                                            item 
                                            xs={12} 
                                            sm={4} 
                                            md={3}
                                        >
                                            <FormControl 
                                                fullWidth 
                                                size="small"
                                            >
                                                <InputLabel>Feedback Type</InputLabel>
                                                <Tooltip 
                                                    title={getTooltipContent(selectedFeedbackTypes)}
                                                    arrow
                                                    placement="top"
                                                    enterDelay={200}
                                                    leaveDelay={200}
                                                >
                                                    <Select
                                                        multiple
                                                        value={selectedFeedbackTypes}
                                                        onChange={handleFeedbackTypeChange}
                                                        renderValue={(selected) => (selected as string[]).join(', ')}
                                                    >
                                                        {props.fbtypes
                                                            .filter(fb => {
                                                                return fb.feedbacktype;
                                                            })
                                                            .map((fb, index) => (
                                                                <MenuItem 
                                                                    key={index} 
                                                                    value={fb.feedbacktype}
                                                                >
                                                                    <Checkbox 
                                                                        checked={selectedFeedbackTypes.indexOf(fb.feedbacktype) > -1} 
                                                                        color="primary" 
                                                                    />
                                                                    {fb.feedbacktype}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>
                                                </Tooltip>
                                            </FormControl>
                                        </Grid>
                                    )}
          
                                    {/*<Grid item xs={12} sm={4} md={3}>
                                        Attachement : <AttachFileIcon/>
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <ClearIcon style={{ color: 'red' }} />
                                    </Grid> */}

                                    {/* File Input */}
                                    {props.totalRating < 5 && (
                                    <div style={{ padding: '10px'}}>
                                        <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center', paddingBottom: '12px' }}>
                                            <Grid item>
                                                <Typography style={{ marginBottom: 'revert'}} >Attachment :</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Files
                                                    // className={classes.fileUpload}
                                                    onChange={props.onFilesChange}
                                                    // onError={props.onFilesError}
                                                    // accepts={['image/*', 'video/*', 'audio/*', '.pdf']}
                                                    onError={handleFilesError}
                                                    accepts={['image/png', 'image/jpeg', 'image/jpg']}        
                                                    multiple
                                                    // maxFiles={5}
                                                    // maxFileSize={100000000}
                                                    maxFileSize={52428800} // 50MB in bytes
                                                    minFileSize={0}
                                                    dropActiveClassName={classes.filesDropzoneActive}
                                                    clickable
                                                >
                                                    <Button 
                                                        color="primary"
                                                        variant="outlined"
                                                        style={{
                                                            background:
                                                                '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                                        }}
                                                    >
                                                     upload file   <AttachFileIcon style={{ fontSize: '18px' }} />
                                                    </Button>
                                                </Files>
                                                <Typography variant="caption" style={{ display: 'block', marginTop: '4px', color: '#666' }}>
                                                    Accepted file types: PNG, JPG, JPEG (Max size: 50MB)
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        {/* <Grid container>
                                            {Array.isArray(props.submitFbFiles) && props.submitFbFiles.length > 0 && 
                                                props.submitFbFiles.map((file, index) => (
                                                    <Grid container key={JSON.parse(JSON.stringify(file)).id}>
                                                        <Grid item xs={6} md={6} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                            {`${JSON.parse(JSON.stringify(file)).filename} - (${JSON.parse(JSON.stringify(file)).sizeReadable})`}
                                                        </Grid>
                                                        <Grid item xs={6} md={6} sm={6}>
                                                            <IconButton
                                                                onClick={props.deleteRowbyId}
                                                                id={JSON.parse(JSON.stringify(file)).id}
                                                                value={JSON.parse(JSON.stringify(file)).filename}
                                                            >
                                                                <ClearIcon style={{ color: 'red' }} />                                                              
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                ))
                                            }
                                        </Grid>  */}
                                        <Grid container spacing={2}>
                                            {Array.isArray(props.submitFbFiles) && props.submitFbFiles.length > 0 &&
                                                props.submitFbFiles.map((file, index) => (
                                                    <Grid container key={JSON.parse(JSON.stringify(file)).id} alignItems="center" spacing={1}>
                                                        <Grid
                                                            item
                                                            xs={10}
                                                            style={{
                                                                backgroundColor: '#f0f0f0',
                                                                padding: '8px',
                                                                borderRadius: '2px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                            {`${JSON.parse(JSON.stringify(file)).filename} - (${JSON.parse(JSON.stringify(file)).sizeReadable})`}
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            xs={2}
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'flex-end',
                                                                alignItems: 'center',
                                                            }}
                                                        >
                                                            <IconButton
                                                                onClick={props.deleteRowbyId}
                                                                id={JSON.parse(JSON.stringify(file)).id}
                                                                value={JSON.parse(JSON.stringify(file)).filename}
                                                            >
                                                                <ClearIcon style={{ color: 'red' }} />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                ))
                                            }
                                        </Grid> 
                                       
                                    </div>
                                     )}
                                </Grid>
                            </CardContent>
                        </Cards>
                 {props.totalRating < 5 && selectedFeedbackTypes.length > 0 ? (
    <Cards className={classes.card}>
        <CardContent>
            <Grid container spacing={2}>
                {filteredFeedbackParameters.map((value, index) => (
                    <Grid item xs={12} key={index}>
                        <Typography 
                            className={classes.colorHeading}
                        >
                            {value.feedbacktype}
                        </Typography>
                        <Grid container>
                            {value.items.map((data, id) => (
                                <Grid item xs={12} md={4} sm={12} key={id}>
                                    <FormGroup>
                                        <FormControlLabel
                                            className={classes.fontValues}
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    id="checkBox"
                                                    color="primary"
                                                    value={data.listtype}
                                                    checked={
                                                        props.selectedCheckedParameters[value.feedbacktype] 
                                                            ? props.selectedCheckedParameters[value.feedbacktype].includes(data.listtype) 
                                                            : false
                                                    }
                                                    onChange={(event) => 
                                                        handleCheckboxChange(
                                                            value.feedbacktype, 
                                                            data.listtype, 
                                                            event.target.checked
                                                        )
                                                    }
                                                />
                                            }
                                            label={data.listtype}
                                        />
                                    </FormGroup>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </CardContent>
    </Cards>
) : null}

                        {/* {props.totalRating !== 5 ?
                            <Cards className={classes.card}>
                                <CardContent>
                                    <GridList cellHeight="auto" className={classes.gridList} cols={3}>
                                        <GridListTile>
                                            <FormControl component="fieldset" className={classes.formControl}>
                                                <FormLabel className={classes.colorHeading} component="legend">General</FormLabel>
                                                <FormGroup>
                                                    {General.map((genralValue, index) => (
                                                        <FormControlLabel
                                                            className={classes.fontValues}
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    id="checkBox"
                                                                    color="primary"
                                                                    value={genralValue}
                                                                    onChange={props.checkedValuesGeneral}
                                                                />}
                                                            label={genralValue}
                                                        />
                                                    ))}
                                                </FormGroup>
                                                <FormHelperText>Be careful</FormHelperText>
                                            </FormControl>
                                        </GridListTile>
                                        <GridListTile>
                                            <FormControl component="fieldset" className={classes.formControl}>
                                                <FormLabel className={classes.colorHeading} component="legend">Anterior</FormLabel>
                                                <FormGroup>
                                                    {Anterior.map((anteriorValue, index) => (
                                                        <FormControlLabel
                                                            className={classes.fontValues}
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    id="checkBox"
                                                                    color="primary"
                                                                    value={anteriorValue}
                                                                    onChange={props.checkedValuesAnterior}
                                                                />}
                                                            label={anteriorValue}
                                                        />
                                                    ))}
                                                </FormGroup>
                                                <FormHelperText>Be careful</FormHelperText>
                                            </FormControl>
                                            <FormControl component="fieldset" className={classes.formControl}>
                                                <FormLabel className={classes.colorHeading} component="legend">Copings</FormLabel>
                                                <FormGroup>
                                                    {Copings.map((copingValue, index) => (
                                                        <FormControlLabel
                                                            className={classes.fontValues}
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    id="checkBox"
                                                                    color="primary"
                                                                    value={copingValue}
                                                                    onChange={props.checkedValuesCopings}
                                                                />}
                                                            label={copingValue}
                                                        />
                                                    ))}

                                                </FormGroup>
                                                <FormHelperText>Be careful</FormHelperText>
                                            </FormControl>
                                        </GridListTile>
                                        <GridListTile>
                                            <FormControl component="fieldset" className={classes.formControl}>
                                                <FormLabel className={classes.colorHeading} component="legend">Model</FormLabel>
                                                <FormGroup>
                                                    {Model.map((model, index) => (
                                                        <FormControlLabel
                                                            className={classes.fontValues}
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    id="checkBox"
                                                                    color="primary"
                                                                    value={model}
                                                                    onChange={props.checkedValuesCopings}
                                                                />}
                                                            label={model}
                                                        />
                                                    ))}

                                                </FormGroup>
                                                <FormHelperText>Be careful</FormHelperText>
                                            </FormControl>
                                            <FormControl component="fieldset" className={classes.formControl}>
                                                <FormLabel className={classes.colorHeading} component="legend">Abutment</FormLabel>
                                                <FormGroup>
                                                    {Abutment.map((abutment, index) => (
                                                        <FormControlLabel
                                                            className={classes.fontValues}
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    id="checkBox"
                                                                    color="primary"
                                                                    value={abutment}
                                                                    onChange={props.checkedValuesCopings}
                                                                />}
                                                            label={abutment}
                                                        />
                                                    ))}

                                                </FormGroup>
                                                <FormHelperText>Be careful</FormHelperText>
                                            </FormControl>
                                            <FormControl component="fieldset" className={classes.formControl}>
                                                <FormLabel className={classes.colorHeading} component="legend">CutBack</FormLabel>
                                                <FormGroup>
                                                    {Cutback.map((cutback, index) => (
                                                        <FormControlLabel
                                                            className={classes.fontValues}
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    id="checkBox"
                                                                    color="primary"
                                                                    value={cutback}
                                                                    onChange={props.checkedValuesCopings}
                                                                />}
                                                            label={cutback}
                                                        />
                                                    ))}

                                                </FormGroup>
                                                <FormHelperText>Be careful</FormHelperText>
                                            </FormControl>
                                        </GridListTile>
                                    </GridList>
                                </CardContent>
                            </Cards>
                            : null} */}
                             <Cards className={classes.card}>
                                    <CardContent>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={12}>
                                                <CssTextField
                                                    fullWidth
                                                    label="Comments"
                                                    autoFocus
                                                    multiline
                                                    rowsMax={4}
                                                    value={props.comments}
                                                    onChange={handleCommentChange}
                                                    error={charCount >= 1000}
                                                    helperText={`${charCount}/1000 characters${charCount >= 1000 ? ' (maximum reached)' : ''}`}
                                                    inputProps={{
                                                        maxLength: 1000
                                                    }}
                                                    FormHelperTextProps={{
                                                        style: {
                                                            marginLeft: 'auto',
                                                            marginRight: 0
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Cards>
                        {/* <Cards className={classes.card}>
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            fullWidth
                                            label="Comments"
                                            autoFocus
                                            multiline
                                            rowsMax={4}
                                            value={props.comments}
                                            onChange={event => props.saveComments(event.target.value as string)}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Cards> */}
                        <Grid container spacing={1} justify="center">
                            <Grid item>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={props.onSubmit}
                                    style={{
                                        background:
                                            '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                    }}
                                >
                                    Send Feedback
                                </Button>
                            </Grid>
                            <Grid item xs={4} sm={3} md={2}>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.submit}
                                    // onClick={props.onReset}
                                    onClick={handleReset}
                                    style={{
                                        background:
                                            '-webkit-linear-gradient(to right, #0083B0, #00B4DB)'
                                    }}
                                >
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default FeedbackPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/FeedbackView.tsx